<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招标/比选管理</el-breadcrumb-item>
        <el-breadcrumb-item>上传投标确认函详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrap">
      <div class="change_inform">
        <div class="title">项目信息</div>
        <el-form :inline="true" :model="PurchaseScheme" class="form_table">
          <el-form-item label="采购编号">{{ PurchaseScheme.SchemeCode }}</el-form-item>
          <el-form-item label="项目名称">{{ PurchaseScheme.ProjectName }}</el-form-item>
          <el-form-item label="投标确认截止时间">{{ PurchaseScheme.TenderConfirmDate }}</el-form-item>
          <el-form-item label="投标截止时间">{{ PurchaseScheme.BiddingDeadline }}</el-form-item>
          <el-form-item label="开标时间">{{ PurchaseScheme.BidOpeningDate }}</el-form-item>
          <el-form-item label="招标文件">
            {{ PurchaseScheme.BiddingFileName }}
            <el-button class="btn" @click.stop="fnDownload(PurchaseScheme.BiddingFileId, PurchaseScheme.BiddingFileName)">下载</el-button>
          </el-form-item>
          <el-form-item v-if="PurchaseScheme.Reason != null && PurchaseScheme.Reason != ''" label="确认函退回原因">{{ PurchaseScheme.Reason }}</el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">招标内容</div>
        <div v-for="(item, index) in TechnicalTransformGroup" :key="index" style="margin: 15px 0">
          <div class="title1">
            <span>包组：{{ item.GroupName }}</span>
          </div>
          <div>
            <el-table class="table_wrap1 table1" :data="item.TechnicalTransformList" border>
              <el-table-column prop="Index" label="序号" width="100"></el-table-column>
              <el-table-column prop="InstrumentName" label="设备名称"></el-table-column>
              <!-- <el-table-column prop="Specification" label="设备型号"></el-table-column> -->
              <el-table-column prop="Count" label="数量（套）" width="140"></el-table-column>
              <el-table-column prop="Remark" label="备注"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="change_inform">
        <div class="title">报名信息</div>
        <el-form :inline="true" :inline-message="true" :model="AcceptInvitation" ref="AcceptInvitation" class="form_table">
          <el-form-item label="投标单位名称">{{ AcceptInvitation.SupplierName }}</el-form-item>
          <el-form-item label="联系人" prop="ProjectLeader">{{ AcceptInvitation.ProjectLeader }}</el-form-item>
          <el-form-item label="联系人手机" prop="Mobile">{{ AcceptInvitation.Mobile }}</el-form-item>
          <el-form-item label="电子邮箱" prop="Email">{{ AcceptInvitation.Email }}</el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">投标确认函</div>
        <el-form :inline="true" ref="AcceptInvitation2" :model="AcceptInvitation" class="form_table">
          <el-form-item prop="FileList" label="投标确认函">
            <el-link v-for="item in AcceptInvitation.FileList" :key="item" :underline="false" @click="fnDownload(item.id, item.name)">{{ item.name }}.pdf</el-link>
          </el-form-item>
          <div class="btn_wrap2">
            <el-button class="btn2" @click="fnDownload(TemplateFileId, TemplateFileName)">下载投标确认模板</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      FileList: [],
      AcceptInvitation: { FileList: [] },
      TechnicalTransforList: [],
      activeName: 'first',
      formInline: {},
      qualificationList: [],
      enclosureList: [],
      type: '',
      PurchaseScheme: {},
      TechnicalTransformGroup: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    fnDownload(fileId, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'Purchase/DownloadFile?FileId=' + fileId + '&token=' + token

      this.downloadfile(this.baseURL + url)
    },
    back() {
      this.$router.push('/InvitationList')
    },
    getList() {
      let config = {
        params: {
          id: this.$route.query.id
        }
      }
      this.getRequest('/Purchase/GetInvitationDetail', config)
        .then((res) => {
          var data = res.data
          if (res.data.errcode == 0) {
            this.TechnicalTransforList = res.data.TechnicalTransforList
            this.PurchaseScheme = res.data.PurchaseScheme
            this.AcceptInvitation = res.data.AcceptInvitation
            this.TemplateFileId = res.data.TemplateFileId
            this.TemplateFileName = res.data.TemplateFileName
            this.TechnicalTransformGroup = res.data.TechnicalTransformGroup
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    download(FileId, remark, fileName) {
      let token = window.localStorage.getItem('loginToken')
      token = token.replace(/\+/g, '%2B')
      var url = 'SupplierLogin/DownLoadFile?fileId=' + FileId + '&remark=' + remark + '&token=' + token + '&fileName=' + fileName
      console.log(this.baseURL + url)
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>
<style lang="scss" scoped>
.mb_nav_pos {
  padding: 5px 0 0;
}
.change_inform {
  .title {
    height: 34px !important;
    line-height: 40px !important;
    border-bottom: 1px solid #95c7f0 !important;
    margin-bottom: 13px;
    padding-top: 15px !important;
  }
  .el-table--border {
    border-bottom: 1px solid #95c7f0 !important;
  }
  ::v-deep .table_wrap1 {
    table {
      margin: 0;
      td,
      tr,
      th {
        border-color: #95c7f0;
      }
      th {
        border-top: 1px solid #95c7f0;
        background-color: #d8eafa;
      }
    }
  }
}

.btn_wrap {
  width: 360px;
  height: 40px;
  text-align: center;
  padding: 10px;
  margin: auto;
}
.btn2 {
  color: #6a96bc;
  border: 1px solid #6a96bc;
  border-radius: 15px;
  padding: 0px 15px;
  margin: 5px 23px;
  height: 24px;
}
.btn {
  color: #6a96bc;
  border: 1px solid #6a96bc;
  border-radius: 8px;
  padding: 0px 15px;
  margin: 5px 23px;
  height: 24px;
}
.EnterpriseInform {
  .content_wrap {
    // padding-top: 15px;
    padding-bottom: 50px;
    margin-bottom: 20px;
  }
  ::v-deep .el-form {
    margin: 0 15px 5px;
    .el-form-item__content {
      justify-content: left;
    }
  }
  .title {
    height: 50px;
    line-height: 50px;
    border: none;
  }
  .record_table {
    margin-top: 0;
  }
  .link {
    cursor: pointer;
  }
}
.filelist {
  margin-bottom: 10px;
}
.btn_wrap2 {
  height: 40px;
  text-align: left;
  padding: 10px;
  margin: auto 30px;
  .btn_1 {
    color: #0099ff;
    background: #fafafa;
    height: 30px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    line-height: 40px;
    display: inline-block;
    border: 1px solid #2db7f5;
    text-align: center;
    border-radius: 23px;
    color: #0099ff;
    background: #fafafa;
    cursor: pointer;
  }
}
.table1 {
  width: 98%;
  margin: 0 1%;
}
.title1 {
  margin: 0 0 5px 2%;
  font-size: 15px;
  font-weight: 600;
}
</style>
